export const SET_COACHES_LOADING = 'SET_COACHES_LOADING';
export const SET_COACHES = 'SET_COACHES';
export const SET_COACHES_ERROR = 'SET_COACHES_ERROR';
export const SET_COACHES_FETCH_TIME = 'SET_COACHES_FETCH_TIME';
